import { render, staticRenderFns } from "./ProductCalculator.vue?vue&type=template&id=b81c50c0"
import script from "./ProductCalculator.vue?vue&type=script&lang=js"
export * from "./ProductCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports